import { PropsWithChildren } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'

import { LanguageSelector } from '@/app/components/LanguageSelector/LanguageSelector'
import { SecondaryButton } from '@/app/components/SecondaryButton'
import { ArrowRight } from '@/app/icons/ArrowRight'
import { MydraIcon } from '@/app/icons/MydraIcon'

type WizardLayoutProps = PropsWithChildren<{
  showBackButton?: boolean
  onBack?: () => void
}>

export function WizardLayout({
  children,
  showBackButton = true,
  onBack,
}: WizardLayoutProps) {
  const navigate = useNavigate()

  const handleBack = () => {
    if (onBack) {
      onBack()
    } else {
      navigate(-1)
    }
  }

  return (
    <>
      <Helmet>
        <style>
          {`
            :root { --hs-beacon-v-offset: 32px !important; }
            .mydra-base-layout { min-height: 0; height: 100vh; }
            @media (max-width: 1600px) {
              :root { --hs-beacon-v-offset: 100px !important; }
            }
          `}
        </style>
      </Helmet>
      <div className="relative flex h-full flex-col md:flex-row">
        <div className="mt-6 flex w-full flex-1 justify-center overflow-y-auto md:order-1 md:mt-0 md:w-1/2 md:bg-cover">
          <div className="relative flex w-full flex-col gap-2 bg-white px-6 pt-2 md:mx-auto md:mt-16 md:w-[606px] md:px-6 md:pt-0">
            <div className="flex w-full items-center justify-between gap-4">
              <MydraIcon className="h-9 w-9 shrink-0 [&_path]:fill-mydra-purple" />
              <div className="flex items-center gap-3">
                <LanguageSelector />
                {showBackButton && (
                  <SecondaryButton
                    className="aspect-square shrink-0 text-mydra-black"
                    onClick={handleBack}
                  >
                    <ArrowRight className="h-3 w-3 rotate-180 transform" />
                  </SecondaryButton>
                )}
              </div>
            </div>
            {children}
          </div>
        </div>
        <div className="relative order-first hidden flex-col items-center justify-center gap-8 p-8 text-center md:order-2 md:flex md:w-1/2">
          <div className="absolute inset-2">
            <img
              src="/images/static/img/hero_bg.jpg"
              alt="Hero background"
              className="h-full w-full rounded-xl object-cover"
            />
          </div>
        </div>
      </div>
    </>
  )
}
